var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreMenuHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5809_14661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1685 12.877C16.1685 13.977 17.0685 14.877 18.1685 14.877C19.2685 14.877 20.1685 13.977 20.1685 12.877C20.1685 11.777 19.2685 10.877 18.1685 10.877C17.0685 10.877 16.1685 11.777 16.1685 12.877ZM14.1685 12.877C14.1685 11.777 13.2685 10.877 12.1685 10.877C11.0685 10.877 10.1685 11.777 10.1685 12.877C10.1685 13.977 11.0685 14.877 12.1685 14.877C13.2685 14.877 14.1685 13.977 14.1685 12.877ZM8.16846 12.877C8.16846 11.777 7.26846 10.877 6.16846 10.877C5.06846 10.877 4.16846 11.777 4.16846 12.877C4.16846 13.977 5.06846 14.877 6.16846 14.877C7.26846 14.877 8.16846 13.977 8.16846 12.877Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5809_14661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(24.1685 0.876953) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreMenuHorizontal);
export default __webpack_public_path__ + "static/media/more-menu-horizontal.dc13db1df6e2990f1e1732bb2a54fa94.svg";
export { ForwardRef as ReactComponent };